export default "__VITE_ASSET__BwG7SZ$J__"